module.exports = __webpack_public_path__ + "img/GainCharisma.4003b911.png";